export const getWebsiteURL = (path) => {
  return "https://eduplanner-dev-website.remotestate.com"+path;
};